<div>
  <!-- information dialog - record can not be deleted due to connections in other objects -->
  <psv-information-dialog></psv-information-dialog>

  <his-search-result #SearchResultComponent
    [showTitle]="true"
    [showNewSearchButton]="true"
    defaultActionRoute="/person/view/:id"
    idColumn="[Person].id"
    defaultColumn="[Person].surname">

    @if (showBackButton) {
      <ng-container customResultButtons>
        <button (click)="navigationService.navigateToLastBackUrl()"><span>{{'common.back' | hisUi }}</span></button>
      </ng-container>
    }

    <ng-template #rowAction let-index="index" let-row="row">
      <!-- detail view -->
      <a routerLink="/person/view/{{row.get('[Person].id')}}" hisImage="magnifier_detail" [title]="'de.his.javang.show' | hisUi"></a>
    </ng-template>
  </his-search-result>
</div>
